"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const TransactionLink_container_1 = __importDefault(require("./TransactionLink.container"));
exports.default = TransactionLink_container_1.default;
//# sourceMappingURL=index.js.map